export { default as MediaSwitch } from './MediaSwitch';
